<div class="container-modal-lateral">
  <div>
    <span class="title-modal-lateral">{{ visualizar ? 'Detalhes Grupo' : 'Criar Grupo' }}</span>
    @if(!visualizar){
      <form [formGroup]="formGrupo" (ngSubmit)="salvar()">
        <div class="main-modal-lateral-edicao">
          @if (grupo.id) {
            <app-slide-toggle-padrao [valor]="grupo.ativo" (changeValue)="grupo.ativo = $event; alteracaoService.camposAlterado()"></app-slide-toggle-padrao>
          }
          <app-form-field formControlName="nome" label="Nome" heightFormField="35px" (changeValue)="alteracaoService.camposAlterado()"></app-form-field>
          <div class="flex-direction-column gap-5 width-25">
            <span class="label">Logo</span>
              @if (logoGrupo) {
                <img [src]="logoGrupo" class="modal-lateral-imagem" alt="Logo do grupo" role="button" tabindex="0" (click)="fileInput.click()" (keydown.enter)="fileInput.click()" />
              } @else {
                <app-button-padrao
                  icon="add_photo_alternate"
                  fontSize="24px"
                  widthIcon="35px"
                  heightIcon="35px"
                  classIcon="material-icons-outlined"
                  borderRightStyle="solid"
                  borderRightWidth="5px"
                  (buttonClick)="fileInput.click()"
                ></app-button-padrao>
              }
              <input type="file" accept="image/*" #fileInput (change)="selecionarLogoGrupo($event); alteracaoService.camposAlterado()" hidden="" />
          </div>
          @if (grupo && grupo.id){
            <div class="flex-direction-column gap-15">
              <app-select-one
                  label="Responsável"
                  campo="nome"
                  widthFormField="100%"
                  heightFormField="35px"
                  [listaInput]="listaUsuarios"
                  [itemSelecionado]="grupo.responsavel"
                  (selecionarItem)="selecionarResponsavel($event)"
              ></app-select-one>
            </div>
          }
          @else {
            <div class="label-lateral">
              <span class="label">Responsável</span>
            </div>
            <div formGroupName="responsavel" class="flex-direction-column gap-10">
              <app-form-field heightFormField="35px" formControlName="email" label="Email"></app-form-field>
              <app-form-field heightFormField="35px" formControlName="nome" label="Nome"></app-form-field>

              <div class="flex gap-10">
                <app-form-field heightFormField="35px" widthFormField="160px" formControlName="telefone" label="Telefone" mask="(00) 90000-0000"></app-form-field>
                <app-form-field heightFormField="35px" widthFormField="160px" formControlName="cpf" label="CPF" mask="000.000.000-00"></app-form-field>
              </div>
            </div>
          }
        </div>
      </form>

    }@else {
      <form [formGroup]="formGrupo">
        <div class="main-modal-lateral-info">
          <div class="container-info-modal-lateral">
            <span class="label">Nome</span>
            <span class="font-12">{{grupo.nome}}</span>
          </div>
          <div class="container-info-modal-lateral">
            <span class="label">Status</span>
            <span class="font-12">{{grupo.ativo ? 'Ativo' : 'Inativo'}}</span>
          </div>
          <div class="container-info-modal-lateral">
            <span class="label">Logo</span>
            @if (grupo.logoExtensao && grupo.uuid) {
              <img [src]="gerarUrl(grupo.uuid, grupo.logoExtensao, 'grupo-logo')" class="modal-lateral-imagem" alt="Logo do grupo" />
            } @else {
              <img src="./assets/icones/no-img-default.png" style="width: 25px; height: 25px" class="modal-lateral-imagem" alt="" />
            }
          </div>
          <div class="container-info-modal-lateral">
            <span class="label">Responsável</span>
            <span class="font-12">{{ grupo.responsavel?.nome ?? '--' }}</span>
          </div>
        </div>
      </form>
    }
  </div>

  @if (!visualizar) {
    <div class="botoes-modal-lateral">
      <app-button-padrao
        width="100%"
        label="Salvar"
        [backgroundColor]="formGrupo.invalid ? 'grey' : 'var(--verde-padrao)'"
        [color]="formGrupo.invalid ? 'dark-grey' : 'white'"
        [type]="'submit'"
        [disabled]="formGrupo.invalid"
        (buttonClick)="salvar()"
      ></app-button-padrao>

      <app-button-padrao
        width="100%"
        label="Cancelar"
        backgroundColor="white"
        color="var(--vermelho-padrao)"
        (buttonClick)="cancelar()"
        borderColor="var(--vermelho-padrao)"
        borderStyle="solid"
        borderWidth="1px"
      ></app-button-padrao>
    </div>
  }
</div>
